/* Milano color chart — progressive enhancement only.
   One job: a staggered reveal of swatch cards as they enter the viewport
   (same pattern as milano-density-guide.js / milano-toppers-guide.js).
   Nothing on /pages/color-chart depends on this file — every swatch is a real
   link and every colour name is real text with JavaScript off.
   Idempotent; theme-editor safe via shopify:section:load. */
(function () {
  'use strict';

  if (window.MilanoColorChart) return;
  window.MilanoColorChart = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-mcc-reveal]:not(.is-revealed)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    Array.prototype.forEach.call(items, function (el) {
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--mcc-delay', Math.min(Math.max(index, 0) * 45, 270) + 'ms');
      observer.observe(el);
    });
  }

  document.documentElement.classList.add('mcc-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals(document);
    });
  } else {
    initReveals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
  });
})();
